<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WOGZyb/tc-custom/9780830843855.jpg?1696024624944" alt="This image is the cover for the book Companions in Suffering"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Companions in Suffering
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>2020 <em>The Gospel Coalition</em> Book Award - Christian Living</strong> </p> <p> <strong>Have you experienced an ongoing trial that left you wrung out emotionally? Do you feel alone in your pain?</strong> </p> <p>Though suffering often leaves us feeling isolated, God invites us into the community of the Trinity and offers us many companions in Scripture. We experience loneliness alongside the exiled Israelites. We journey with David as he pleads to God for rescue. With Asaph we confess our unbelief. With Job we learn to lament. With Mary and Martha we learn to wait.</p> <p>In God's community, there is sweet fellowship, even in the hardest of circumstances. Journey in these pages with Wendy Alsup through her story of suffering, and more importantly, with the God who walks with us in the wilderness.</p> <p>This warm and contemplative book also includes a helpful appendix for those who companion a suffering loved one.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wendy Alsup, Trillia J. Newbell
      </h2>
      
      <p class="authorDescription body article"><p>Wendy Alsup began her public ministry as deacon of women's theology and teaching at her church in Seattle, and now lives on her family farm in South Carolina, where she teaches math at a local community college and is a mother to her two boys. She writes at theologyforwomen.org and is a member of the Pelican Project. She is the author of a number of books, including <em>Is the Bible Good for Women?</em> and <em>Practical Theology for Women.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?315b8759